import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=37a5f2e2&scoped=true"
import script from "./bottomRight.vue?vue&type=script&lang=js"
export * from "./bottomRight.vue?vue&type=script&lang=js"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=37a5f2e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f2e2",
  null
  
)

export default component.exports